import Config from 'config/settings';
import { device } from 'utils/device';
import { VideoPlayer } from '../media/VideoPlayer';

export class VideoSwitch extends VideoPlayer {
	public config = {
		desktopSrc: null,
		mobileSrc: null,
		autoplay: false,
		resizeMode: 'orientation',
		mobileWidth: Config.mobileWidth
	};

	private _layout;

	public create(): void {
		this._layout = this._isPortrait() ? 'portrait' : 'landscape';
		let src = this._layout == 'portrait' ? this.config.mobileSrc : this.config.desktopSrc;

		this.$container.querySelector('source').setAttribute('src', src);
		(this.$container as HTMLVideoElement).load();


		super.create();
	}

	public destroy() {
		this.$container = null;
		super.destroy();
	}

	public resize() {
		let newLayout = this._isPortrait() ? 'portrait' : 'landscape';

		if (newLayout != this._layout) {
			let src = newLayout == 'portrait' ? this.config.mobileSrc : this.config.desktopSrc;
			this.$container.querySelector('source').setAttribute('src', src);
			(this.$container as HTMLVideoElement).load();
			this._layout = newLayout;
		}
	}

	private _isPortrait() {
		return (
			(this.config.resizeMode == 'width' && device.innerWidth <= this.config.mobileWidth) ||
			(this.config.resizeMode == 'orientation' &&
				device.isPortraitDevice &&
				device.innerWidth <= this.config.mobileWidth)
		);
	}
}
